"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const useStyles = (0, styles_1.makeStyles)(theme => ({
    root: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginRight: theme.spacing(2)
    },
    bordered: {
        display: 'flex',
        borderRadius: 10,
        backgroundColor: theme.palette.text.secondary.lighten(0.83).getWithAlpha(0.083),
        border: `2px solid ${theme.palette.secondary.main}`,
        justifyContent: 'center',
        alignItems: 'center'
    },
    instructions: {
        justifyContent: 'center'
    },
    star: {
        width: 59,
        height: 61
    },
    instructionItem: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: theme.spacing(0.5),
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center'
        }
    },
    instructionItemContainer: {
        display: 'flex'
    },
    instructionsText: {
        fontWeight: 600,
        textAlign: 'center',
        alignSelf: 'center'
    },
    eligibleGameItem: {
        [theme.breakpoints.up('md')]: {
            paddingLeft: 4
        }
    },
    ticketEntry: {
        padding: `${theme.spacing(2)}px !important`,
        [theme.breakpoints.down('md')]: {
            borderWidth: 0,
            backgroundColor: 'transparent',
            marginTop: theme.spacing(2),
            padding: '0 !important'
        }
    },
    ticketEntryButton: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    }
}));
exports.default = useStyles;
//# sourceMappingURL=SuperBonusShortcutStyle.js.map